"use client"

import { toast } from "react-toastify"
import styled from "styled-components"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const Message = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
`

const Actions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`

const BaseButton = styled.button`
  padding: 6px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease;
`

const CancelButton = styled(BaseButton)`
  background-color: #f3f4f6;
  color: #374151;

  &:hover {
    background-color: #e5e7eb;
  }
`

const ConfirmButton = styled(BaseButton)`
  background-color: #2563eb;
  color: #ffffff;

  &:hover {
    background-color: #1d4ed8;
  }
`

function ConfirmToastContent({ message, onConfirm, onCancel }) {
  return (
    <Wrapper>
      <Message>{message}</Message>
      <Actions>
        <CancelButton onClick={onCancel}>No</CancelButton>
        <ConfirmButton onClick={onConfirm}>Sí</ConfirmButton>
      </Actions>
    </Wrapper>
  )
}

export function showConfirmToast(message) {
  return new Promise((resolve) => {
    const toastId = toast(
      <ConfirmToastContent
        message={message}
        onConfirm={() => {
          toast.dismiss(toastId)
          resolve(true)
        }}
        onCancel={() => {
          toast.dismiss(toastId)
          resolve(false)
        }}
      />,
      {
        position: "top-center",
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
        style: {
          borderRadius: "12px",
          boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
          padding: "16px",
          minWidth: "280px",
        },
      }
    )
  })
}
